import { createContext } from "react";

export const CombinedPaymentContext = createContext(false);
